import { render, staticRenderFns } from "./SocialPostGallery.vue?vue&type=template&id=727d81f2"
import script from "./SocialPostGallery.vue?vue&type=script&lang=js"
export * from "./SocialPostGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports